import i18next from 'i18next';
import merge from 'lodash/merge';
import reportsEn from '@modules/reports/tmReconciliationDynamic/locale';
import mainEn from '@/locales/main/en';
import commonEn from '@/locales/_common/en';
import { LogService } from '@/services';

const fallbackLanguage = 'en';
const supportedLanguages = ['en'];
const extractSupportedLanguages = (langs) => {
    if (langs && langs.length) {
        const ret = langs.filter((lang) => supportedLanguages.indexOf(lang) !== -1);

        return ret.length ? ret : [fallbackLanguage];
    }
    return supportedLanguages;
};
const getResources = (langs, customLocales = {}) => {
    const ret = {};

    if (langs.indexOf('en') !== -1) {
        ret.en = {
            _common:
                customLocales._common && customLocales._common.en
                    ? merge(commonEn, customLocales._common.en)
                    : commonEn,
            main:
                customLocales.main && customLocales.main.en
                    ? merge(mainEn, customLocales.main.en)
                    : mainEn,
            reports: reportsEn,
        };
    }

    return ret;
};

export default {
    create: ({ languages, locales } = {}) => {
        const langs = extractSupportedLanguages(languages);
        const resources = getResources(langs, locales || {});

        i18next.init({
            debug: process.env.NODE_ENV !== 'production',
            lng: langs[0],
            fallbackLng: langs,
            ns: ['dashboard', 'main'],
            resources,
            parseMissingKeyHandler: () => {
                if (process.env.NODE_ENV === 'production')
                    LogService.warn('Missing Key from translation file');
                return 'Invalid Key';
            },
            interpolation: {
                format: (value, format) => {
                    switch (format) {
                        case 'uppercase':
                            return value.toUpperCase();
                        case 'lowercase':
                            return value.toLowerCase();
                        default:
                            return value;
                    }
                },
            },
        });

        return i18next;
    },
};
